export default __webpack_public_path__ + "static/media/the_viridescent_hunt.904062bf.png";